export default "__VITE_ASSET__De0dz31N__"